import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';
import * as fromAuthStore from '@apps/auth/store';
import { Impersonation } from '@apps/root/models';
import { ImpersonateComponent } from '@admin/impersonate/impersonate.component';
import { PopinModalService } from '@ui/misc/popin-modal/popin-modal.service';
import { BackAuthEntitiesExternalODataRequested } from '@apps/back/store/auth/entities/external/entities-external.actions';
import { BackAuthUsersExternalODataRequested } from '@apps/back/store/auth/users/external/users-external.actions';

@Component({
    selector: 'aa-header',
    templateUrl: './header.component.html',
    styleUrls: [
        './header.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit
{
    public isBackAuthorized: Observable<boolean> = of(false);
    public isImpersonateAuthorized: Observable<boolean> = of(false);
    public isImpersonated: Observable<boolean> = of(false);
    public isAdmin: Observable<boolean> = of(false);

    constructor (
        private store: Store<IAuroraState>,
        private routerStore: Store<any>,
        private popinModalService: PopinModalService
    )
    {
    }

    ngOnInit (): void
    {
        this.isImpersonateAuthorized = this.store
            .select(fromAuthStore.getBackAuthorization);
        this.isImpersonated = this.store
            .pipe(
                select(fromRootStore.getRootImpersonation),
                map((impersonation: Impersonation) => impersonation !== null)
            );
        this.isAdmin = this.routerStore
            .pipe(
                select(fromRootStore.selectUrl),
                filter((url: string | null): url is string => (url??'').length !== 0),
                map((url: string) => url.includes('/admin'))
            );
    }

    onImpersonate = () =>
    {
        this.store.dispatch(
            BackAuthEntitiesExternalODataRequested()
        );

        this.store.dispatch(
            BackAuthUsersExternalODataRequested()
        );
        
        this.popinModalService.create(ImpersonateComponent, { width: 52 });
    };
}
